// Texto de mensagem do WhatsApp → HTML seguro pra bolha do chat: escapa tudo primeiro e só então aplica a marcação que o
// contato vê formatada (*negrito*, _itálico_, ~riscado~, ```monoespaçado```). Quebra de linha vira <br>.
// Mesmas regras de borda do WhatsApp: o marcador fica colado no texto e entre espaços/pontuação ("2*3*4" não vira negrito).

export function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

const EDGE_BEFORE = '(^|[\\s(\\[{"\'«¿¡])'
const EDGE_AFTER = '(?=$|[\\s.,;:!?)\\]}"\'»…])'

function inline(marker: string, tag: string): [RegExp, string] {
  const m = marker.replace(/[*~]/g, c => `\\${c}`)
  return [new RegExp(`${EDGE_BEFORE}${m}(\\S(?:[^\\n]*?\\S)?)${m}${EDGE_AFTER}`, 'g'), `$1<${tag}>$2</${tag}>`]
}

const RULES: [RegExp, string][] = [inline('*', 'b'), inline('_', 'i'), inline('~', 's')]

/** HTML da bolha: texto escapado + marcação do WhatsApp + <br> nas quebras de linha. */
export function whatsAppToHtml(text: string | null | undefined): string {
  if (!text) return ''
  // Monoespaçado primeiro: dentro dele nada mais é formatado.
  const parts = escapeHtml(text).split(/```([\s\S]+?)```/)
  return parts
    .map((part, i) => i % 2 === 1
      ? `<code class="wa-mono">${part}</code>`
      : RULES.reduce((html, [pattern, replacement]) => html.replace(pattern, replacement), part))
    .join('')
    .replace(/\n/g, '<br>')
}
